const CustomStoreListing = {
  sports: {
    csl: '01sports',
    cslKey: 'Sports',
  },
  city: {
    csl: '01city',
    cslKey: 'City',
  },
  education: {
    csl: '01education',
    cslKey: 'Education',
  },
  tv: {
    csl: '01tv',
    cslKey: 'TV',
  },
  lifestyle: {
    csl: '01lifestyle',
    cslKey: 'Lifestyle',
  },
  business: {
    csl: '01business',
    cslKey: 'Business',
  },
  world: {
    csl: '01world',
    cslKey: 'World',
  },
  astrology: {
    csl: '01astrology',
    cslKey: 'Astrology',
  },
  gadgetsnews: {
    csl: '01gadgetsnews',
    cslKey: 'gadgets-news',
  },
};

export { CustomStoreListing as default };
